import React from 'react';
import { Lock } from 'lucide-react';
interface ProgressBarProps {
  currentQuestion: number;
  totalQuestions: number;
}
export function ProgressBar({
  currentQuestion,
  totalQuestions
}: ProgressBarProps) {
  return <div className="flex items-center justify-center gap-4 text-xs md:text-sm text-[#5a7c7a] mb-6" data-id="element-43">
      <div className="flex items-center gap-1.5" data-id="element-44">
        <Lock className="w-3 h-3" data-id="element-45" />
        <span data-id="element-46">Your answers are confidential</span>
      </div>
      
    </div>;
}